<template>
  <div class="permiss-wrap">
    <div class="title-wrap">
      <!-- <span class="title">成员权限</span> -->
      <!-- <span class="edit">
        <el-button plain @click="changeType">
          {{ permissText }}
        </el-button>
      </span> -->
    </div>
    <div class="permiss-content">
      <div class="box">
        <div class="content-title">
          <span class="title1"> 权限范围</span>
          <span class="title2">权限</span>
        </div>

        <div class="checkbox">
          <span class="desc">浏览权限</span>
          <el-checkbox v-model="checked1">工作室概况查看权限</el-checkbox>
          <!-- <el-checkbox v-model="checked2">成员清退权限</el-checkbox>
          <el-checkbox v-model="checked3">工作室活跃数据查看权限</el-checkbox>
          <el-checkbox v-model="checked4">工作室收入数据查看权限</el-checkbox> -->
        </div>
        <!--不支持修改-->
        <!-- <div class="checkbox" v-else>
          <el-checkbox v-model="checked1" disabled
            >工作室收入数据查看权限</el-checkbox
          >
          <el-checkbox v-model="checked2">成员清退权限</el-checkbox>
          <el-checkbox v-model="checked3">工作室活跃数据查看权限</el-checkbox>
          <el-checkbox v-model="checked4">工作室收入数据查看权限</el-checkbox>
        </div> -->
      </div>
      <!-- <div class="box">
        <div class="content-title">普通成员权限</div>
        <div class="checkbox" v-if="permissLoading">
          <el-checkbox v-model="checked5">工作室收入数据查看权限</el-checkbox>
          <el-checkbox v-model="checked6">分成权限</el-checkbox>
          <el-checkbox v-model="checked7">任务设置权限</el-checkbox>
          <el-checkbox v-model="checked8">数据全选</el-checkbox>
        </div>
        <div class="checkbox" v-else>
          <el-checkbox v-model="checked5" disabled
            >工作室收入数据查看权限</el-checkbox
          >
          <el-checkbox v-model="checked6">分成权限</el-checkbox>
          <el-checkbox v-model="checked7">任务设置权限</el-checkbox>
          <el-checkbox v-model="checked8">数据全选</el-checkbox>
        </div>
      </div> -->
      <div class="submit">
        <el-button plain @click="save"> 保存 </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getPermiss, setPermiss } from '@/api/studio';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      // permissText: '编辑',
      // permissLoading: false,
      checked1: false,
      checked5: false,
    };
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  mounted() {
    this.getPermissData();
  },
  methods: {
    //获取当前权限
    async getPermissData() {
      let data = { json: 1 };
      const res = await getPermiss(data);
      if (res.data.v1m_income) {
        this.checked1 = true;
      } else {
        this.checked1 = false;
      }
    },
    save() {
      this.setPermissData();
      // this.permissText = '编辑';
    },
    //更新权限
    async setPermissData() {
      let data = {
        uin: this.userInfo.uin,
        v1m_income: this.checked1 ? 1 : 0,
        json: 1,
      };
      const res = await setPermiss(data);
      // this.permissText = '编辑';
      // this.permissLoading = false;
      if (res.code == 0) this.$message.success('权限修改成功');
      if (res.data.v1m_income) this.checked1 = true;
      else this.checked1 = false;
    },
    // changeType() {
    //   if (this.permissText == '编辑') {
    //     this.permissLoading = true;
    //     this.permissText = '取消';
    //   } else {
    //     this.permissLoading = false;
    //     this.permissText = '编辑';
    //   }
    // }
  },
};
</script>
<style lang="scss" scoped>
.permiss-wrap {
  min-height: 375px;
  .title-wrap {
    .title {
      font-size: 20px;
    }
    .edit {
      float: right;
      //border: 1px solid #ccc;
      padding: 2px 20px;
      ::v-deep.el-button {
        width: 80px;
      }
    }
  }
  .permiss-content {
    //margin-left: 35px;
    margin-top: 22px;
    color: #4d4d4d;
    .box {
      .content-title {
        font-size: 16px;
        padding-bottom: 8px;
        // border-bottom: 1px solid #d9d9d9;
        .title1 {
          margin-right: 60px;
        }
      }
      .checkbox {
        display: flex;
        //flex-direction: column;
        //margin-left: 125px;
        color: #3c3c3c;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 15px;
        font-size: 14px;
        margin-top: 15px;
        //column-rule: ;
        .desc {
          margin-right: 70px;
        }
        ::v-deep.el-checkbox {
          font-size: 16px;
          border-radius: 8px;
          border: none;
          padding-bottom: 8px;
          .el-checkbox__label {
            color: #262626;
          }
        }
      }
    }
    .submit {
      margin-bottom: 10px;
      display: flex;
      // justify-content: center;
      margin-top: 220px;
      ::v-deep.el-button {
        width: 120px;
        height: 50px;
        font-size: 18px;
        color: #ffffff;
        background-color: #fd9b21;
        //border: 1px solid #dcdfe6;
      }
    }
  }
}
</style>
